"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCurrency = void 0;
var _intlFormatter = require("@godaddy/intl-formatter");
var _LocalizationHelper = require("./LocalizationHelper");
// eslint-disable-next-line max-params
const formatCurrency = (price, market, currency, formatFlags, intlNumberFormatOptions = {}) => {
  const gdCurrency = new _intlFormatter.Currency();
  const currencyDisplay = gdCurrency.formatDecimal(price, market || (0, _LocalizationHelper.getMarket)(), currency?.toUpperCase() || (0, _LocalizationHelper.getCurrency)(), {
    excludeDecimal: false,
    ...formatFlags
  }, {
    useGrouping: true,
    ...intlNumberFormatOptions
  });
  return currencyDisplay;
};
exports.formatCurrency = formatCurrency;